<div id="_star-sys-display_component-wrapper_" class="flex flex-col">
  <!-- STAR-SYSTEMS -->
  <div class="p-2 flex flex-wrap iBTTiny:flex-col lanPixel2xl:flex-row">
    <div id="_SYSTEM-HEX" class="text-white flex flex-wrap items-stretch iBTTiny:flex-col lanPixel2xl:flex-row">
      <!-- STARLESS-NEXUS -->
      @if (starSystem()?.type === "Starless Nexus") {
        <div id="_Starless-Nexus" class="py-4 text-white flex border-1">Starless Nexus</div>
      }

      <!-- STAR-SYSTEMS -->
      @else {
        @for (star of starSystem()?.stars; track star._id) {
          <div id="_STAR-SYSTEM" class="py-4 text-white border flex box-border flex-expand">
            <!-- STAR -->
            <div id="_STAR" class="p-2 flex-none">
              <starfire-image class="starImage tooltip-tr" [attr.data-tooltip]="star.type" [folder]="'stars'" [name]="star.type"></starfire-image>
            </div>

            <!-- PLANETS & MOONS -->
            <div id="_PLANTS & MOONS" class="flex flex-grow flex-col">
              @for (planet of star.planets; track planet._id) {
                <div class="border-0 border-blue-400 flex">
                  <div id="_PLANET" class="flex flex-grow flex-expand justify-start">
                    <div class="w-24 h-24 flex items-center justify-center">
                      <starfire-image class="tooltip-tr" [ngClass]="{ planetImage: planet.type != 'I', planetImageSmall: planet.type === 'I' }" [folder]="'planets'" [name]="planet.image || planet.type" [attr.data-tooltip]="planet.type + ' (' + planet.strategicHex + ')'"></starfire-image>
                    </div>
                    <div id="_Planet-Info" class="mx-2 flex-col items-start justify-center whitespace-nowrap">
                      @if (informationPlanetHash(); as iph) {
                        @if (iph[planet._id]; as ip) {
                          <div class="planetInfo">Eco: {{ planet.multiplier }} * {{ ip.rei }}</div>
                        }
                      }
                      @if (racePops(); as pps) {
                        @if (pps[planet._id]; as pp) {
                          <div class="planetInfo">PU: {{ pp.pu }}</div>
                          <div class="planetInfo">IU: {{ pp.iu }}</div>
                        }
                      }
                      @if (otherPops(); as opsh) {
                        @if (opsh[planet._id]; as ops) {
                          @for (op of ops | keyObject; track op.key) {
                            <div class="planetInfo">
                              Race: {{ raceLookup.get(op.key)?.name }}<br />
                              PU: {{ op.value.pu }} / IU: {{ op.value.iu }}
                            </div>
                          }
                        }
                      }
                    </div>
                  </div>

                  @if (displayMoons() && planet.moons.length > 0) {
                    <div id="_MOONS" class="ml-2 text-yellow-300 border-0 border-yellow-400 flex flex-none flex-col">
                      <!-- put moons here -->
                      @for (moon of planet.moons; track moon._id) {
                        <div class="p-2 flex flex-none items-center whitespace-nowrap">
                          <starfire-image class="moonImage tooltip-tr" [attr.data-tooltip]="moon.type + ', Orbit: ' + moon.distance + ', Radian: ' + moon.radian" [folder]="'moons'" [name]="moon.image || moon.type"> </starfire-image>
                          <div id="moonInfo" class="px-2 inline-flex flex-col items-start">
                            @if (informationPlanetHash(); as iph) {
                              @if (iph[moon._id]; as ip) {
                                <div class="moonInfo">Eco: {{ moon.multiplier }} * {{ ip.rei }}</div>
                              }
                            }
                            @if (racePops(); as pps) {
                              @if (pps[moon._id]; as pp) {
                                <div class="moonInfo">pu: {{ pp.pu }}</div>
                                <div class="moonInfo">iu: {{ pp.iu }}</div>
                              }
                            }
                            @if (otherPops(); as opsh) {
                              @if (opsh[moon._id]; as ops) {
                                @for (op of ops | keyObject; track op.key) {
                                  <div class="moonInfo">
                                    Race: {{ raceLookup.get(op.key).name }}<br />
                                    PU: {{ op.value.pu }} / IU: {{ op.value.iu }}
                                  </div>
                                }
                              }
                            }
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }
      }
    </div>

    <!-- SURVEYS -->
    @if (race.techLevel > 0) {
      <div id="_surveys_" class="px-2 border flex flex-col">
        @if (displayControls().primaryHasPlanets) {
          <!-- PRIMARY-SURVEY -->
          <div id="_primary-survey_" class="p-4 flex flex-col">
            <div class="text-1.25 font-bold ism-gold">Primary Surveys:</div>
            <div class="px-4 text-right flex flex-col items-end justify-end">
              <!-- Primary-Habitable -->
              @if (displayControls().primarySurveyElements.h) {
                <div id="_primary-habitable_" class="flex items-center justify-between">
                  <div class="p-2 text-1.25 text-white text-right">Habitable:</div>
                  <div class="w-8">
                    <completion-indicator [points]="informationStarSystem()?.surveyPlanetHabitable || 0" [pointsMax]="50"></completion-indicator>
                  </div>
                </div>
              }
              <!-- Primary-Non-Habitiable -->
              @if (displayControls().primarySurveyElements.n) {
                <div id="_Primary_Non-Habitable" class="flex items-center justify-between">
                  <div class="p-2 text-1.25 text-white text-right">Non-Habitable:</div>
                  <div class="w-8">
                    <completion-indicator [points]="informationStarSystem()?.surveyPlanetNonHabitable || 0" [pointsMax]="50"></completion-indicator>
                  </div>
                </div>
              }
              <!-- Primary-Asteroids -->
              @if (displayControls().primarySurveyElements.a) {
                <div id="_primary-asteroids_" class="flex items-center justify-between">
                  <div class="p-2 text-1.25 text-white text-right">Asteroid(s):</div>
                  <div class="w-8">
                    <completion-indicator [points]="informationStarSystem()?.surveyAsteroid || 0" [pointsMax]="50"></completion-indicator>
                  </div>
                </div>
              }
            </div>
          </div>
        }

        <!-- SECONDARY-SURVEY -->
        @if (displayControls().secondaryHasPlanets) {
          <div id="_second-survey" class="p-4 flex flex-col">
            <div class="text-1.25 font-bold ism-gold">Secondary Surveys:</div>
            <div class="px-4 text-right flex flex-col items-end justify-end">
              <!-- Secondary-Habitable -->
              @if (displayControls().secondarySurveyElements.h) {
                <div id="_Secondary-Habitable" class="text-white flex items-center justify-between">
                  <div class="p-2 text-1.25 text-right">Habitable:</div>
                  <div class="w-8">
                    <completion-indicator [points]="informationStarSystem()?.surveyPlanetHabitable2 || 0" [pointsMax]="50"></completion-indicator>
                  </div>
                </div>
              }
              <!-- Secondary-Non-habitable -->
              @if (displayControls().secondarySurveyElements.n) {
                <div id="_Secondary_Non-Habitable" class="flex items-center justify-between">
                  <div class="p-2 text-1.25 text-white text-right">Non-Habitable:</div>
                  <div class="w-8">
                    <completion-indicator [points]="informationStarSystem()?.surveyPlanetNonHabitable2 || 0" [pointsMax]="50"></completion-indicator>
                  </div>
                </div>
              }
              <!-- Secondary-Asteroids -->
              @if (displayControls().secondarySurveyElements.a) {
                <div id="_Secondary-Asteroids" class="flex items-center justify-between">
                  <div class="p-2 text-1.25 text-white text-right">Asteroid(s):</div>
                  <div class="w-8">
                    <completion-indicator [points]="informationStarSystem()?.surveyAsteroid2 || 0" [pointsMax]="50"></completion-indicator>
                  </div>
                </div>
              }
            </div>
          </div>
        }

        <!-- WARP-POINT SURVEY -->
        <div id="_WP-Survey" class="p-4 flex flex-col">
          <div class="text-1.25 font-bold ism-gold">Warp Point Surveys:</div>
          <div class="px-4 text-right flex flex-col items-end justify-end">
            <!-- WP-Rough Survey -->
            <div id="_WP-Rough-Survey" class="flex items-center justify-between">
              <div class="p-2 text-1.25 text-white text-right">Rough:</div>
              <div class="w-8">
                <completion-indicator [points]="informationStarSystem()?.surveyWarpPass1 || 0" [pointsMax]="200"></completion-indicator>
              </div>
            </div>
            <!-- WP-Detailed Survey -->
            <div id="_wp-detailed-survey_" class="flex items-center justify-between">
              <div class="p-2 text-1.25 text-white text-right">Detailed:</div>
              <div class="w-8">
                <completion-indicator [points]="informationStarSystem()?.surveyWarpPass2 || 0" [pointsMax]="200" [pointsMax]="200"></completion-indicator>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>

  <!-- WARP POINTS FOUND -->
  @if (race.techLevel > 0) {
    @if (informationWarpPoints(); as iwp) {
      <div id="_wp-Table" class="px-2 py-4 flex flex-1 flex-col">
        <div class="text-1.25 font-bold ism-gold">Warp Points</div>
        <table class="mx-2 w-full">
          <tr class="data">
            <th class="text-center w-1/7 ism-gold">Destination</th>
            <th class="text-center w-1/7 ism-gold">Location</th>
            <th class="text-center w-1/7 ism-gold">Open</th>
            <th class="text-center w-1/7 ism-gold">Distance</th>
            <th class="text-center w-1/7 ism-gold">Radian</th>
            <th class="text-center w-1/7 ism-gold">Capacity</th>
            <th class="text-center w-1/7 ism-gold">Type</th>
          </tr>
          @for (informationWarpPoint of informationWarpPoints(); track informationWarpPoint._id) {
            <tr class="data">
              <td id="_Destination" class="text-center data tooltip-t" [attr.data-tooltip]="'Destination / To Explore'">
                @if (informationWarpPoint.turnExplored > 0) {
                  <a (click)="changeStarSystemId(informationWarpPoint.warpPoint?.destinationStarSystem || undefined)">
                    {{ informationWarpPoint.warpPoint?.destination }}
                  </a>
                } @else {
                  unexplored
                }
              </td>
              <td class="text-center tooltip-tr" [attr.data-tooltip]="'Location'">{{ informationWarpPoint.strategicHex }}</td>
              <td class="text-center tooltip-tr" [attr.data-tooltip]="'Open'">{{ (informationWarpPoint.warpPoint?.type || 0) < 12 ? "Open" : "Closed" }}</td>
              <td class="text-center tooltip-tr" [attr.data-tooltip]="'Distance'">{{ informationWarpPoint.distance }}</td>
              <td class="text-center tooltip-tr" [attr.data-tooltip]="'Radian'">{{ informationWarpPoint.radian }}</td>
              <td class="text-center tooltip-tr" [attr.data-tooltip]="'Capacity'">{{ informationWarpPoint.warpPoint?.capacity }}</td>
              <td class="text-center tooltip-tl" [attr.data-tooltip]="'Type'">{{ informationWarpPoint.warpPoint?.type }}</td>
            </tr>
          }
        </table>
      </div>
    }
    <!-- NO WARP POINTS -->
    @else {
      <div id="_wp-none-discovered_" class="py-4 w-11/12 flex flex-col flex-wrap iBTTiny:hidden sm:flex">
        <div class="p-2 font-bold text-1.875 ism-gold">No Warp Points Discovered</div>
      </div>
    }
  }
</div>
